import * as React from 'react';

import * as style from './TextField.css';
import { Field } from '../Field';

export interface ITextFieldProps {
  published?: boolean;
}

export const TextField: React.FC<React.PropsWithChildren<ITextFieldProps>> = props => {
  const { children, published } = props;

  return (
    <Field published={published} className={style['container']}>
      {children}
    </Field>
  );
};
